import React, { useMemo, useEffect, useState } from "react";

const getEnRouteWXFromData = (data, trainingMode) => {
  if (!trainingMode) {
    return null;
  }

  let trainingData = null;

  if (Array.isArray(data?.training) && data.training.length > 0) {
    trainingData = data.training[0];
  } else if (data?.adList) {
    trainingData = Array.isArray(data.adList) ? data.adList[0] : data.adList;
  }

  return trainingData?.enRouteWX || null;
};

export const EnRouteWX = ({ data, trainingMode = false }) => {
  const [enRouteWX, setEnRouteWX] = useState(null);

  useEffect(() => {
    const result = getEnRouteWXFromData(data, trainingMode);
    setEnRouteWX(result);
  }, [data, trainingMode]);

  if (!enRouteWX) {
    return (
      <div className={"content-container"}>
        <p style={{ fontSize: "18px", fontWeight: 700, marginBottom: "8px" }}>
          ENROUTE WX
        </p>
        <p>ENROUTE WX data not found</p>
      </div>
    );
  }

  const content = Array.isArray(enRouteWX) ? enRouteWX.join("\n") : enRouteWX;

  return (
    <div className={"content-container"}>
      <p style={{ fontSize: "18px", fontWeight: 700, marginBottom: "8px" }}>
        ENROUTE WX
      </p>
      <pre
        style={{ marginBottom: "16px", marginTop: 0, whiteSpace: "pre-wrap" }}
      >
        {content}
      </pre>
    </div>
  );
};
